import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import VirtualizedSelect from 'react-virtualized-select';
import { Grid, Dropdown, Form, Segment, Icon, Button, Header } from 'semantic-ui-react';
import { getSavedSearch, postSaveSearch, putSaveSearch, getInventoryReport, getStatusCodes } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { NotificationManager } from 'react-notifications';
import * as SimpleReactValidator from 'simple-react-validator';
import MessageBox from '../../ui/MessageBox';
import { addressType, balanceType, dosCondition, timeFrame, cancelReportColumns } from '../../utils/defaults';
import Loading from '../Loading';
const initialState = {
    acxAmountReferred: "",
    acxCancelCnd: null,
    acxCancelFrom: "",
    acxCancelTimeFrame: "",
    acxCancelTo: "",
    acxCreatedCnd: null,
    acxCreatedFrom: "",
    acxCreatedTimeFrame: "",
    acxCreatedTo: "",
    acxDlpCnd: null,
    acxDlpFrom: "",
    acxDlpTimeFrame: "",
    acxDlpTo: "",
    acxDosCnd: null,
    acxDosFrom: "",
    acxDosTimeFrame: "",
    acxDosTo: "",
    acxTotal: "",
    astStatusCode: [],
    astStatusGroup: [],
    cltClientIds: [],
    coaAddressType: "",
    coaCity: "",
    coaPostalCode: "",
    conFirstName: "",
    conLastName: "",
    cphPhone: "",
    reportColumns: [],
    saveSearchDesc: "",
    saveSearchName: "",
    share: 'N',
    acxAmountReferredCnd: "",
    acxTotalCnd: "",
    crpCorporateId: "",
    issId: 0,
}
class InventoryReport extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            searchIndex: initialState,
            // statusCodeList: [],
            statusGroup: [],
            //  statusCode: [],
            errorMessage: [],
            open: false,
            loading: false
        };
    }

    componentDidMount() {
        this.props.addItem("helpFile", "reports_inventory.md");
        this.getStatusCodesDetails();
        if (this.props.params && this.props.params.id) {
            this.setState({
                searchIndex: {
                    ...this.state.searchIndex,
                    issId: this.props.params.id
                }
            }, () => {
                this.getSavedSearchItem();
            })
        }
    }

    componentDidUpdate(prevProps) {
        return false;
    }

    getSavedSearchItem = () => {
        getSavedSearch(this.props.items.currentCorporate, this.state.searchIndex.issId).then((response) => {
            if (response !== null && response instanceof Object) {
                this.setState({
                    searchIndex: response
                });
            }

        })

    }

    getStatusCodesDetails = () => {
        this.props.addItem("statusCode", []);
        this.props.addItem("statusCodeList", []);
        getStatusCodes(this.props.items.currentCorporate, this.state.searchIndex.issId).then((response) => {
            if (response !== null && response instanceof Array) {
                let statusCodeList = this.groupBy(response, "stsStatusGroup");
                let statusCode = response.map((status, index) => {
                    return {
                        key: index,
                        text: status.stsStatusCode + " - " + status.stsStatusDesc,
                        label: status.stsStatusCode + " - " + status.stsStatusDesc,
                        value: status.stsStatusCode,
                        group: status.stsStatusGroup
                    }
                });
                let i = 0;
                let statusGroup = [];
                for (var status in statusCodeList) {
                    if (statusCodeList.hasOwnProperty(status)) {
                        var objt = {
                            key: i++,
                            value: status,
                            text: status
                        }
                        statusGroup.push(objt);
                    }
                }
                this.props.addItem("statusCode", statusCode);
                this.props.addItem("statusCodeList", statusCode);
                this.setState({
                    // statusCodeList: statusCode,
                    //  statusCode: statusCode,
                    statusGroup: statusGroup
                });
            }
        })
    }

    groupBy = (items, key) => items.reduce(
        (result, item) => ({
            ...result,
            [item[key]]: [
                ...(result[item[key]] || []),
                item,
            ],
        }),
        {},
    );

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    handleChange = (e, evt) => {
        this.setState({
            searchIndex: {
                ...this.state.searchIndex,
                [evt.name]: evt.value
            }
        }, () => { this.resetDateFilter(evt.name); this.resetStatusCodeFilter(evt.name) })
    }

    handleVirtualChange = (e) => {
        this.setState({
            searchIndex: {
                ...this.state.searchIndex,
                astStatusCode: e
            }
        })
    }

    handleCheckbox = (e, { name, checked }) => {
        this.setState({
            searchIndex: {
                ...this.state.searchIndex,
                [name]: (checked) ? "Y" : "N"
            }
        });
    }

    resetStatusCodeFilter = (name) => {
        if (name.indexOf("astStatusGroup") >= 0) {
            let statusGroup = this.state.searchIndex.astStatusGroup;
            // this.setState({
            //     statusCode: this.props.item.statusCodeList.filter((status) => {
            //         return statusGroup.indexOf(status.group) >= 0;
            //     })
            // });
            let statusCode = this.props.items.statusCodeList.filter((status) => {
                return statusGroup.indexOf(status.group) >= 0;
            });
            this.props.addItem("statusCode", statusCode);
        }
    }

    resetDateFilter = (name) => {
        if (name.indexOf("TimeFrame") >= 0) {
            this.setState({
                searchIndex: {
                    ...this.state.searchIndex,
                    [name.replace("TimeFrame", "Cnd")]: null,
                    [name.replace("TimeFrame", "To")]: "",
                    [name.replace("TimeFrame", "From")]: "",
                }
            });
        }
        if (name.indexOf("Cnd") >= 0) {
            this.setState({
                searchIndex: {
                    ...this.state.searchIndex,
                    [name.replace("Cnd", "TimeFrame")]: ""
                }
            });
        }
    }

    handleSaveSearch = () => {
        if (this.validator.allValid()) {
            let saveSearch = this.state.searchIndex;
            saveSearch.crpCorporateId = this.props.items.currentCorporate;
            saveSearch.astStatusCode = saveSearch.astStatusCode.map((item) => {
                return (item instanceof Object) ? item.value : item;
            });
            saveSearch.issId = (this.props.params && this.props.params.id) ? this.props.params.id : 0;
            if (saveSearch.issId > 0) {
                putSaveSearch(this.props.items.currentCorporate, saveSearch).then((response) => {
                    if (response !== null) {
                        NotificationManager.success('Success', 'Updated successfully.');
                    }
                });
            } else {
                postSaveSearch(this.props.items.currentCorporate, saveSearch).then((response) => {
                    if (response !== null) {
                        NotificationManager.success('Success', 'Saved successfully.');
                    }
                });
            }
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                open: true
            });
            this.forceUpdate();
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loading: true
            }, () => {
                let saveSearch = this.state.searchIndex;
                saveSearch.crpCorporateId = this.props.items.currentCorporate;
                saveSearch.astStatusCode = saveSearch.astStatusCode.map((item) => {
                    return (item instanceof Object) ? item.value : item;
                });
                getInventoryReport(this.props.items.currentCorporate, saveSearch).then((response) => {
                    if (response !== null) {
                        let disposition = response.request.getResponseHeader('Content-Disposition');
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            let matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                let filename = matches[1].replace(/['"]/g, '');
                                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                                    // IE workaround for "HTML7007: One or more blob URLs were 
                                    // revoked by closing the blob for which they were created. 
                                    // These URLs will no longer resolve as the data backing 
                                    // the URL has been freed."
                                    window.navigator.msSaveBlob(new Blob([response.data]), filename);
                                } else {
                                    const url = window.URL.createObjectURL(new Blob([response.data]));
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.setAttribute('download', filename);
                                    document.body.appendChild(link);
                                    link.click();
                                }
                            }
                        }
                    }
                }).then(() => {
                    this.setState({
                        loading: false
                    });
                })
            });
        } else {
            this.validator.showMessages();
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                open: true
            })
            this.forceUpdate();
        }

    }

    reset = () => {
        this.setState({
            searchIndex: initialState
        })
    }

    close = () => {
        this.setState({
            open: false
        });
    }
    render() {
        if (this.state.loading) {
            return (<Loading />)
        }
        return (
            <div>
                {this.state.loading ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Reports" child={[{ name: "Inventory", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment inverted className="grey">
                                    <Header as="h4">Inventory Report</Header>
                                </Segment>
                                <Segment>
                                    <Form className="small">
                                        <Form.Group>
                                            <Form.Field width={16}>
                                                <Button className="small right floated" as={Link} to={"/report/savedSearch"}>
                                                    View All Saved Search Preferences
                                        </Button>
                                            </Form.Field>
                                        </Form.Group>
                                        <Segment>
                                            <Form.Group>
                                                <Form.Field width={4} className="required">
                                                    <label>Select Client ID(s):</label>
                                                    <Dropdown placeholder='Select Client ID(s)' className="fluid" multiple search selection options={this.props.items.clients.map((client) => { client.disabled = !client.allowedtoviewreport; return client; })} name="cltClientIds" value={this.state.searchIndex.cltClientIds} onChange={this.handleChange} ></Dropdown>
                                                    {this.validator.message('Client ID(s)', this.state.searchIndex.cltClientIds, 'required')}
                                                </Form.Field>
                                                <Form.Field width={4}>
                                                    <label>Select Status Code Group(s):</label>
                                                    <Dropdown placeholder='Select Status Code Group(s)' className="fluid" multiple search selection options={this.state.statusGroup} name="astStatusGroup" value={this.state.searchIndex.astStatusGroup} onChange={this.handleChange} ></Dropdown>
                                                </Form.Field>
                                                <Form.Field width={4} >
                                                    <label>Select Status Code(s):</label>
                                                    <VirtualizedSelect fluid
                                                        name="astStatusCode"
                                                        placeholder='Select Status Code(s)'
                                                        autosize={false}
                                                        multi={true}
                                                        value={this.state.searchIndex.astStatusCode} onChange={this.handleVirtualChange} options={this.props.items.statusCode}
                                                    >
                                                    </VirtualizedSelect>
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                        <Segment>
                                            <Form.Group>
                                                <Form.Field width={4}>
                                                    <Form.Input label='First Name:' placeholder='First Name' name="conFirstName" value={this.state.searchIndex.conFirstName} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={4}>
                                                    <Form.Input label='Last Name:' placeholder='Last Name' name="conLastName" value={this.state.searchIndex.conLastName} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={4} >
                                                    <Form.Input label='Phone:' placeholder='Phone' name="cphPhone" value={this.state.searchIndex.cphPhone} onChange={this.handleChange} />
                                                </Form.Field>
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Field width={4}>
                                                    <label>Address:</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={addressType} name="coaAddressType" value={this.state.searchIndex.coaAddressType} onChange={this.handleChange}></Dropdown>
                                                </Form.Field>
                                                <Form.Field width={4}>
                                                    <Form.Input label='City:' placeholder='City' name="coaCity" value={this.state.searchIndex.coaCity} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={4} >
                                                    <Form.Input label='Zip Code:' placeholder={this.props.t("zipcode")} name="coaPostalCode" value={this.state.searchIndex.coaPostalCode} onChange={this.handleChange} />
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                        <Segment>
                                            <Form.Group>
                                                <Form.Field width={3}>
                                                    <label>Current Balance:</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={balanceType} name="acxTotalCnd" value={this.state.searchIndex.acxTotalCnd} onChange={this.handleChange}></Dropdown>
                                                </Form.Field>
                                                <Form.Field width={5} >
                                                    <label>&nbsp;</label>
                                                    <Form.Input placeholder='Whole Dollar Amount (e.g., 100)' name="acxTotal" value={this.state.searchIndex.acxTotal} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={3} className="required">
                                                    <label>Original Balance:</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={balanceType} name="acxAmountReferredCnd" value={this.state.searchIndex.acxAmountReferredCnd} onChange={this.handleChange}></Dropdown>
                                                    {this.validator.message('Original Balance', this.state.searchIndex.acxAmountReferredCnd, 'required')}
                                                </Form.Field>
                                                <Form.Field width={5} >
                                                    <label>&nbsp;</label>
                                                    <Form.Input placeholder='Whole Dollar Amount (e.g., 100)' name="acxAmountReferred" value={this.state.searchIndex.acxAmountReferred} onChange={this.handleChange} />
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                        <Segment>
                                            <Form.Group>
                                                <Form.Field width={3}>
                                                    <label>Date Of Service:</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={dosCondition} name="acxDosCnd" value={this.state.searchIndex.acxDosCnd} onChange={this.handleChange}></Dropdown>
                                                </Form.Field>
                                                <Form.Field width={3} >
                                                    <label>&nbsp;</label>
                                                    <Form.Input placeholder='mm/dd/yyyy' type="date" name="acxDosFrom" value={this.state.searchIndex.acxDosFrom} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={3} >
                                                    <label>&nbsp;</label>
                                                    <Form.Input placeholder='mm/dd/yyyy' type="date" name="acxDosTo" value={this.state.searchIndex.acxDosTo} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={1} />
                                                <Form.Field width={5}>
                                                    <label>Or — Pick a Time Frame (Overrides specified dates.):</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={timeFrame} name="acxDosTimeFrame" value={this.state.searchIndex.acxDosTimeFrame} onChange={this.handleChange}></Dropdown>
                                                </Form.Field>
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Field width={3}>
                                                    <label>Date Assigned:</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={dosCondition} name="acxCreatedCnd" value={this.state.searchIndex.acxCreatedCnd} onChange={this.handleChange}></Dropdown>
                                                </Form.Field>
                                                <Form.Field width={3} >
                                                    <label>&nbsp;</label>
                                                    <Form.Input placeholder='mm/dd/yyyy' type="date" name="acxCreatedFrom" value={this.state.searchIndex.acxCreatedFrom} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={3} >
                                                    <label>&nbsp;</label>
                                                    <Form.Input placeholder='mm/dd/yyyy' type="date" name="acxCreatedTo" value={this.state.searchIndex.acxCreatedTo} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={1} />
                                                <Form.Field width={5}>
                                                    <label>Or — Pick a Time Frame (Overrides specified dates.):</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={timeFrame} name="acxCreatedTimeFrame" value={this.state.searchIndex.acxCreatedTimeFrame} onChange={this.handleChange}></Dropdown>
                                                </Form.Field>
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Field width={3}>
                                                    <label>Last Payment:</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={dosCondition} name="acxDlpCnd" value={this.state.searchIndex.acxDlpCnd} onChange={this.handleChange}></Dropdown>
                                                </Form.Field>
                                                <Form.Field width={3} >
                                                    <label>&nbsp;</label>
                                                    <Form.Input placeholder='mm/dd/yyyy' type="date" name="acxDlpFrom" value={this.state.searchIndex.acxDlpFrom} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={3} >
                                                    <label>&nbsp;</label>
                                                    <Form.Input placeholder='mm/dd/yyyy' type="date" name="acxDlpTo" value={this.state.searchIndex.acxDlpTo} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={1} />
                                                <Form.Field width={5}>
                                                    <label>Or — Pick a Time Frame (Overrides specified dates.):</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={timeFrame} name="acxDlpTimeFrame" value={this.state.searchIndex.acxDlpTimeFrame} onChange={this.handleChange}></Dropdown>
                                                </Form.Field>
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Field width={3}>
                                                    <label>Cancel Date:</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={dosCondition} name="acxCancelCnd" value={this.state.searchIndex.acxCancelCnd} onChange={this.handleChange}></Dropdown>
                                                </Form.Field>
                                                <Form.Field width={3} >
                                                    <label>&nbsp;</label>
                                                    <Form.Input placeholder='mm/dd/yyyy' type="date" name="acxCancelFrom" value={this.state.searchIndex.acxCancelFrom} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={3} >
                                                    <label>&nbsp;</label>
                                                    <Form.Input placeholder='mm/dd/yyyy' type="date" name="acxCancelTo" value={this.state.searchIndex.acxCancelTo} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={1} />
                                                <Form.Field width={5}>
                                                    <label>Or — Pick a Time Frame (Overrides specified dates.):</label>
                                                    <Dropdown placeholder='Select' className="fluid" search selection options={timeFrame} name="acxCancelTimeFrame" value={this.state.searchIndex.acxCancelTimeFrame} onChange={this.handleChange}></Dropdown>
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                        <Segment>
                                            <Form.Group>
                                                <Form.Field width={9} className="required">
                                                    <label>Select column name(s) for your report.</label>
                                                    <Dropdown placeholder='Select' className="fluid" multiple search selection options={cancelReportColumns} name="reportColumns" value={this.state.searchIndex.reportColumns} onChange={this.handleChange}></Dropdown>
                                                    {this.validator.message('Select column name(s) for your report', this.state.searchIndex.reportColumns, 'required')}
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                        <Segment>
                                            <Form.Group>
                                                <Form.Field width={4}>
                                                    <label>Name of Saved Search Preference:</label>
                                                    <Form.Input placeholder='Save as..' type="text" name="saveSearchName" value={this.state.searchIndex.saveSearchName} onChange={this.handleChange} />
                                                </Form.Field>
                                                <Form.Field width={5}>
                                                    <label>&nbsp;</label>
                                                    <Form.Checkbox label='Share this template with other users?' name="share" checked={this.state.searchIndex.share === 'Y' ? true : false} onChange={this.handleCheckbox} />
                                                </Form.Field>
                                                <Form.Field width={7}>
                                                    <label>Description:</label>
                                                    <Form.TextArea rows={2} name="saveSearchDesc" value={this.state.searchIndex.saveSearchDesc} onChange={this.handleChange} />
                                                </Form.Field>
                                            </Form.Group>
                                            <Form.Group>
                                                <Form.Field width={16}>
                                                    <Button className="ui button small floated" onClick={this.handleSaveSearch}>
                                                        Save Search Preferences
                                        </Button>
                                                </Form.Field>
                                            </Form.Group>
                                        </Segment>
                                        <Form.Group>
                                            <Form.Field width={16}>
                                                <Button secondary className="small right floated" onClick={this.handleSubmit}>
                                                    <Icon name="external alternate" />
                                                    Export Table Data
                                        </Button>
                                                <Button secondary className="small right floated" onClick={this.reset}>
                                                    Reset
                                        </Button>
                                            </Form.Field>
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox {...this.props} size="mini" box={11} open={this.state.open} close={this.close} required={this.state.errorMessage} />
            </div>
        );
    }
}
export default InventoryReport;


// WEBPACK FOOTER //
// ./src/app/ui/reports/InventoryReport.js